import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserDataService } from './user-data.service';


@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    { provide: UserDataService, useClass: UserDataService, multi: false }
  ]
})
export class UserDataModule { }
